<template lang="">

    <div>
        <zona-detalle :client="client" v-if="params.tipo==0" :id="parseInt(params.id)" :datos="estados" :subscribeSuccess="subscribeSuccess" :tipo="tipo"/>
        <zona-detalle v-if="params.tipo==2" :ruta="params.ruta" :tipo="tipo"/>
    </div>
</template>
<script>
    import ZonaDetalle from '../components/ZonaDetalle.vue'
export default {
    components: {
        ZonaDetalle,
    },
    props: {
        client: Object,
        estados:Object,
        tipo:Number,
       
    },
    data() {
        return {
            subscription: {
                topic: '',
                qos: 0,
            },
        }
    },
    computed:{
        params() {
            return this.$route.params;
        },
    },
    destroyed() {
      console.log("destruyendo Home")
      this.doUnSubscribe();
    },
    created(){
        //this.subscribeSuccess=false;
        let makesubscribe=false;
       
        switch (this.params.id) {
            case 1:
                makesubscribe=true;
                this.subscription.topic='centrifugacion'
                break;
            case 2:
                makesubscribe=true;
                this.subscription.topic='barrenado'
                break;
            case 4:
                makesubscribe=true;
                this.subscription.topic='trafos'
                //this.customSuscribe('potencia_inmovil');
                break;
            case 5:
                makesubscribe=true;
                this.subscription.topic='evaporativo'
                break;
            case 6:
                makesubscribe=true;
                this.subscription.topic='mantenimiento'
                break;
            case 7:
                makesubscribe=true;
                this.subscription.topic='pozo'
                break;
            case 8:
                makesubscribe=true;
                this.subscription.topic='incendios'
                break;
            case 9:
                makesubscribe=true;
                this.subscription.topic='greentech'
                break;
            case 10:
                makesubscribe=true;
                this.subscription.topic='compresores'
                break;
            case 11:
                makesubscribe=true;
                this.subscription.topic='hornos'
                break;
                case 12:
                makesubscribe=true;
                this.subscription.topic='filtro_prensa'
                break;
        
            default:
                break;
        }
        if(makesubscribe)this.doSubscribe();

       
        
        
    },
    methods: {

        doSubscribe() {
            this.subscribeSuccess = false
            this.realData={}
            const { topic, qos } = this.subscription;
            console.log(this.subscription);
            // alert("eee")
            this.client.subscribe(topic, { qos }, (error, res) => {
                if (error) {
                console.log('Subscribe to topics error', error)
                return
                }
                this.subscribeSuccess = true
                
                console.log('Subscribe to topics res', res)
            })
        },
        doUnSubscribe() {
            const { topic } = this.subscription;
            console.log("Desusbcripcion de general");
            this.client.unsubscribe(topic, error => {
                if (error) {
                    console.log('Unsubscribe error', error)
                }
            })
        },
        // recepcion(message){
        //     console.log("Estoy en esta recepcion")
        //     console.log(message);
        //     this.estados=message;
        // }
    },
}
</script>
<style lang="">
    
</style>